import "@esri/calcite-components/components/calcite-block";
import "@arcgis/map-components/components/arcgis-area-measurement-3d";
import "@arcgis/map-components/components/arcgis-direct-line-measurement-3d";

import texts from "../../assets/texts/texts";

function Measure() {
  return (
    <>
      <calcite-block
        collapsible
        heading={texts.widgets.measure.direction}
        scale="l"
        icon-start="measure-line"
      >
        <arcgis-direct-line-measurement-3d referenceElement="viewDiv">
          {" "}
        </arcgis-direct-line-measurement-3d>
      </calcite-block>
      <calcite-block
        collapsible
        heading={texts.widgets.measure.area}
        scale="l"
        icon-start="measure-area"
      >
        <arcgis-area-measurement-3d referenceElement="viewDiv">
          {" "}
        </arcgis-area-measurement-3d>
      </calcite-block>
    </>
  );
}

export default Measure;
